import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import { useStopwatch } from "react-timer-hook";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import { CiCalculator1 } from "react-icons/ci";
import { VscReferences } from "react-icons/vsc";
import { BsThreeDotsVertical, BsExclamationTriangle } from "react-icons/bs";
import Question from "./MathQuestion";
import axios from "axios";
import Timer from "./Timer";
import { motion } from "framer-motion";
import { UserContext } from "../../context/UserContext";
import { BASELINE } from "../../util";
import Review from "./Review";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import ReferenceSheet from './ReferenceSheet';
import { v4 as uuidv4 } from 'uuid';
import { useLocation } from 'react-router-dom';
import { FaHandBackFist } from "react-icons/fa6";
import { MdDashboard } from "react-icons/md";

const ACTQuizfromdashboard = ({ free, freesat }) => {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const location = useLocation();
  const responseData = location.state?.data;
  const [questionsarr, setquestionsarr] = useState([]);
  const [timeLeft, setTimeLeft] = useState(null);
  const [showCalculator, setShowCalculator] = useState(false);
  const [questionOverViewOpen, setQuestionOverviewOpen] = useState(false);
  const [showReference, setShowReference] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [bookmarkedQuestions, setBookMarkedQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [error, setError] = useState('');
  const [loadingQuestions, setLoadingQuestions] = useState(false);
  const [showDirectionModalRef, setShowDirectionRefModal] = useState(false);
  const [breaks, setbreaks] = useState(true);

  const [test_id, settest_id] = useState(uuidv4());
  const [showOptions, setShowOptions] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [context, setContext] = useState('');

  const [timerActive, setTimerActive] = useState(false);
  const timerRef = useRef(null);

  const { start, reset } = useStopwatch({ autoStart: false }); // Use stopwatch for untimed mode
  const displayMinutes = timeLeft !== null ? Math.floor(timeLeft / 60) : 0;
  const displaySeconds = timeLeft !== null ? timeLeft % 60 : 0;

  const [askedConfirmation, setAskedConfirmation] = useState([]);
  const [showanswer, setshowanswer] = useState(false);
  const [result, setResult] = useState([]);
  const [questionTimers, setQuestionTimers] = useState([]);
  const [disableAutosave, setDisableAutosave] = useState(false);
  const [autotimer, setautotimer] = useState(false);
  const [autotutor, setautotutor] = useState(false);
  const [original_tid, setoriginal_tid] = useState("");

  useEffect(() => {

    setLoadingQuestions(true);
    let globalIndex = 0;
    let allQuestions = [];

    const fetchData = async () => {
      try {

        let res = await axios.get(BASELINE + "get/act/quiz/by/qids", { params: { qid: questionsarr } });

        if (res.data.length < 1) {
          toast.error("Questions With these topics not found. Try other topics for now by going back")
        } else {
          start();
        }

        let mappedQuestions = res.data.map((question) => {
          return {
            ...question,
            index: globalIndex++,
            answered: false,
            bookMarked: false,
            crossedOutOptions: [],
            selectedOption: null,
            section: responseData.tag
          };
        })

        allQuestions = [...allQuestions, ...mappedQuestions];

        setQuestions(allQuestions);
        setCurrentQuestion(allQuestions[0]);
        setLoadingQuestions(false);
      } catch (error) {
        console.error('Failed to fetch data:', error);
        // Handle errors if needed
      }
    };

    if (questionsarr.length > 0) {
      fetchData();
      setResult(new Array(questionsarr.length).fill(undefined));
    }
  }, [questionsarr]);

  async function handleLocalStorageData(currentTest) {
    if (user.role === 'teacher') {
      settest_id(currentTest);
    } else {
      if (localStorage.getItem('hw') === 'true' && localStorage.getItem('original_text')) {
        settest_id(currentTest);
        setoriginal_tid(localStorage.getItem('original_text'));
      } else if (localStorage.getItem('diagnostic') === 'true') {
        settest_id(uuidv4());
      } else if (localStorage.getItem('hw') === 'true') {
        settest_id(uuidv4());
        setoriginal_tid(currentTest);
      } else {
        settest_id(currentTest);
      }
    }
    setDisableAutosave(false);
    try {
      const response = await axios.get(BASELINE + 'getautosavebytid', { params: { tid: currentTest } });
      // 백엔드에서 autosave 데이터가 배열 형태로 오는지 확인
      const autosaveArray = (response.data.data && Array.isArray(response.data.data))
        ? response.data.data
        : [];
      const savedData = autosaveArray.length > 0 ? autosaveArray[0] : null;

      if (savedData) {
        let jsonsetting = JSON.parse(savedData.Setting);
        let jsondata = JSON.parse(savedData.quiz_data);
        let qrr = jsondata.questions;

        setautotutor(jsonsetting?.tutormode);
        setAskedConfirmation(jsonsetting?.tutorasked);
        setResult(jsonsetting?.result || []);

        const qanswers = jsondata.qanswers ? jsondata.qanswers : [];
        const qbookmarks = jsondata.qbookmarks ? jsondata.qbookmarks : [];

        // Fetch questions based on the type of test
        let res = await axios.get(BASELINE + "get/act/quiz/by/qids", { params: { qid: qrr } });

        // 만약 res.data가 배열이 아니라면 res.data.data에서 배열을 추출하거나 빈 배열 사용
        const questionsData = Array.isArray(res.data)
          ? res.data
          : (res.data.data && Array.isArray(res.data.data) ? res.data.data : []);

        // Map the questions and prepare the state for displaying them
        let mappedQuestions = questionsData.map((question, idx) => ({
          ...question,
          index: idx,
          answered: false,
          selectedOption: qanswers[idx] || null,
          bookMarked: qbookmarks[idx] || false,
          crossedOutOptions: [],
        }));

        setQuestions(mappedQuestions);

        // Restore the timer correctly based on the mode
        if (jsonsetting.timedMode === true) {
          setautotimer(true);
          startCountdownTimer(jsonsetting.timeLeft); // Start countdown timer
        } else {
          startStopwatch(jsonsetting.timeLeft); // Start stopwatch from the restored time
        }

        const questionIndex = jsondata.questions.findIndex((question, index) => {
          // Convert each value to string and remove all whitespace
          const questionStr = String(question).replace(/\s/g, "");
          const savedIdStr = String(savedData.questionIds).replace(/\s/g, "");
          return questionStr === savedIdStr;
        });

        if (questionIndex >= 0) {
          setCurrentQuestion(mappedQuestions[questionIndex]);
        } else {
          setCurrentQuestion(mappedQuestions[0]);
        }

        // Remove localStorage item after a delay
        setTimeout(() => {
          setLoadingQuestions(false);
          localStorage.removeItem('currentTest');
        }, 2000);
      }
    } catch (error) {
      console.error("Error fetching autosave data:", error);
    }
  }

  const stopTimer = () => {
    // 타이머를 비활성화하고 setInterval을 클리어합니다.
    setTimerActive(false);
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
  };

  useEffect(() => {
    const savedTestId = localStorage.getItem("test_id");
    if (!savedTestId) {
      setDisableAutosave(false);
    } else {
      setDisableAutosave(true);
    }
  }, []);

  const autosaveData = async () => {
    // 예시로 저장할 데이터 구성 (필요에 따라 항목 추가)
    const now = new Date();
    const formattedDate = now.toISOString().slice(0, 19).replace('T', ' ');
    const qids = questions.map((q) => q.q_num); // 문제 ID 배열
    const qanswers = questions.map((q) => q.selectedOption);
    const qbookmarks = questions?.map(question => question.bookMarked);
    const mode = questions.length > 0 ? questions[0].subject : "";
    // 북마크 상태나 기타 문제 상태도 필요하다면 추가

    // 예시 autosave 데이터 객체 구성
    const data = {
      test_id: test_id,
      timeLeft: timeLeft,
      questionIds: currentQuestion?.q_num,
      questions: qids,
      qanswers: qanswers,
      qbookmarks: qbookmarks,
      // 추가 항목들 (예: section, 사용자 정보 등)
      user_id: user.u_id,
      date: formattedDate,
      type: 'QUIZ',
      id: 'ACT',
      name: (() => {
        const c = localStorage.getItem('hw_classname') || '';
        const t = localStorage.getItem('testname') || '';
        return localStorage.getItem('hw') === 'true' && c ? `${c} - ${t}` : 'ACT Quiz';
      })(),
      mode: mode,
      tutormode: responseData?.tutorModeActive || autotutor,
      timedMode: responseData?.timedModeActive || autotimer,
    };

    try {
      // axios POST 요청: 서버에 autosave 데이터 저장
      await axios.post(BASELINE + "autosave", { params: { data: JSON.stringify(data) } });
    } catch (error) {
      console.error("Autosave 에러:", error.message);
    }
  };

  useEffect(() => {
    // autosave가 비활성 상태(disableAutosave)가 아니라면 호출
    if (!disableAutosave) {
      autosaveData();
    }
    // currentQuestion, questions, timeLeft 등이 변경될 때마다 실행
  }, [currentQuestion, user, questions, test_id, timeLeft]);

  async function askforhelp() {
    var data = {
      questionidsarr: questionsarr,
      student_id: user.u_id,
      type: "ACT",
      tag: responseData.tag,
      test_id: test_id
    };

    if (window.confirm("Are you sure you want to get help?")) {
      axios.post(BASELINE + 'post/question/set', [data])
        .then(response => {
          // Handle different responses based on status codes
          if (response.status === 201) {
            window.alert("If you have an assigned teacher, then the teacher will contact you.");
          } else if (response.status === 409) {
            window.alert("A help request with this test ID already exists.");
          } else {
            window.alert("Unexpected response from the server: " + response.status);
          }
        })
        .catch(error => {
          // Handle errors based on the status code returned from the server
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            const status = error.response.status;
            if (status === 409) {
              window.alert("A help request with this test ID already exists.");
            } else if (status === 500) {
              window.alert("Internal server error. Please try again later.");
            } else {
              window.alert("An error occurred: " + error.response.status);
            }
          } else if (error.request) {
            // The request was made but no response was received
            window.alert("No response from the server. Please check your network connection.");
          } else {
            window.alert("Error: " + error.message);
          }
        });
    } else {
      window.alert("Help request cancelled.");
    }

  }

  useEffect(() => {
    let timerId;
    if (currentQuestion && result[currentQuestion.index] === undefined) {
      timerId = setInterval(() => {
        setQuestionTimers(prevTimers => {
          const newTimers = [...prevTimers];
          if (newTimers[currentQuestion.index] === undefined) {
            newTimers[currentQuestion.index] = 0;
          }
          newTimers[currentQuestion.index] += 1;
          return newTimers;
        });
      }, 1000); // Update every second
    }

    return () => clearInterval(timerId); // Clear interval when question changes or component unmounts
  }, [currentQuestion, result]);

  const handleSubmit2 = () => {
    const questionId = currentQuestion.qid;
    const reportFrom = user.first_name + " " + user.last_name;

    // Do something with questionId, reportFrom, and context

    var data = {
      questionId: questionId,
      name: reportFrom,
      context: context,
      type: "ACT"
    }

    axios.post(BASELINE + 'questions/report/note', [data])
      .then(response => {
        alert('Report submitted successfully!');
      })
      .catch(error => {
      });

    setContext('');
    setShowModal(false);
  };

  const handleContextChange = (event) => {
    setContext(event.target.value);
  };

  const handleReportClick = useCallback(() => {
    setShowModal(true);
  }, []);

  const handleCloseModal = () => {
    // Clear the context and close the modal
    setContext('');
    setShowModal(false);
  };

  useEffect(() => {
    var elt = document.getElementById('calculator');
    var calculator = window.Desmos?.GraphingCalculator(elt, {
      graphpaper: true,
      keypad: true
    });
    return () => {
      calculator?.destroy();
    }
  }, [showCalculator]);

  useEffect(() => {
    if (questions.length > 0 && currentQuestion) {
      let q = questions.find((ques => ques?.qid === currentQuestion?.qid));
      setCurrentQuestion(q);
    }
  }, [questions]);


  useEffect(() => {
    const currentTest = localStorage.getItem('currentTest');

    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        setShowOptions(false);
      }
    };

    document.addEventListener('keydown', handleEsc);

    if (currentTest) {
      handleLocalStorageData(currentTest).then(() => {
        if (responseData && responseData.timedModeActive === true) {
          startCountdownTimer(responseData.timeLimit * 60);
        } else if (responseData && responseData.timedModeActive === false) {
          startStopwatch(0);
        }
      });
    } else {
      if (responseData) {
        if (responseData.timedModeActive) {
          startCountdownTimer(responseData.timeLimit * 60);
        } else {
          startStopwatch(0);
        }
        setquestionsarr(responseData.questionIds);
      } else {
        getQuestions();
      }
    }

    // 컴포넌트 언마운트 시 타이머 정리
    return () => {
      document.removeEventListener('keydown', handleEsc);
      stopTimer();
    };
  }, []);

  useEffect(() => {
    const currentTest = localStorage.getItem('currentTest');
    const runLocalStorageFlow = async () => {
      if (currentTest) {
        await handleLocalStorageData(currentTest);
      } else {
        if (responseData) {
          // test_id 설정
          if (responseData.test_id) {
            settest_id(responseData.test_id);
          } else {
            settest_id(uuidv4());
          }
          // 타이머 모드에 따라 설정
          if (responseData.timedModeActive === true) {
            startCountdownTimer(responseData.timeLimit * 60);
          } else {
            startStopwatch(0);
          }
          // 질문 ID 배열이 존재하고 길이가 0보다 큰지 확인
          if (responseData.questionIds && responseData.questionIds.length > 0) {
            setquestionsarr(responseData.questionIds);
          } else {
            // 질문 ID 배열이 없으면 getQuestions를 호출해서 데이터를 가져옴
            await getQuestions();
          }
        } else {
          await getQuestions();
          setDisableAutosave(false);
        }
      }
    };

    runLocalStorageFlow();

    return () => {
      stopTimer();
    };
  }, [responseData]);

  // Countdown 모드: startingTime(초)부터 1초마다 감소
  const startCountdownTimer = (startingTime) => {
    setTimeLeft(startingTime);
    setTimerActive(true);
    timerRef.current = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          toast.error("Time's Up!");
          handleSubmit(); // 시간이 다 되면 자동 제출
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  // Stopwatch 모드: 0부터 1초마다 증가
  const startStopwatch = (startingTime) => {
    setTimeLeft(startingTime);
    setTimerActive(true);
    timerRef.current = setInterval(() => {
      setTimeLeft(prev => prev + 1);
    }, 1000);
  };

  async function getQuestions() {
    try {
      setLoadingQuestions(true);
      let res = await axios.get(BASELINE + "get/act/quiz/by/qids", { params: { qid: questionsarr } });
      // res.data가 배열인지, 아니면 res.data.data에 배열이 있는지 확인
      const questionsData = Array.isArray(res.data)
        ? res.data
        : (res.data.data && Array.isArray(res.data.data) ? res.data.data : []);

      let mappedQuestions = questionsData.map((question, idx) => ({
        ...question,
        index: idx,
        answered: false,
        bookMarked: false,
        crossedOutOptions: [],
        selectedOption: null
      }));

      setQuestions(mappedQuestions);
      setCurrentQuestion(mappedQuestions[0]);
      setLoadingQuestions(false);
      // Initialize askedConfirmation array
      setAskedConfirmation(mappedQuestions.map(() => false));
    } catch (err) {
      setLoadingQuestions(false);
      toast.error(err.message);
      setError(err.message);
    }
  }

  async function handleSubmit() {
    try {
      let obtainedMarks = 0;
      let newDat = questions.map((question) => {
        var correctAnswer;

        if (question.answer) {
          try {
            // First, try to parse the string into a JSON array
            correctAnswer = JSON.parse(question.answer);

            // If the result is not an array, convert it to an array
            if (!Array.isArray(correctAnswer)) {
              correctAnswer = [correctAnswer.toString().toLowerCase()];
            } else if (correctAnswer.length === 1) {
              // If there's only one element in the array, convert it to lowercase
              correctAnswer = [correctAnswer[0].toLowerCase()];
            }
          } catch (e) {
            // If JSON.parse fails, treat it as a single answer string
            correctAnswer = [question.answer.toLowerCase()];
          }
        } else {
          correctAnswer = ["No Answer"];
        }

        let isCorrect = false;
        if (Array.isArray(correctAnswer)) {
          for (let i = 0; i < correctAnswer.length; i++) {
            if (String(question.selectedOption).trim() === String(correctAnswer[i]).trim()) {
              isCorrect = true;
              break;
            }
          }
        } else {
          isCorrect = question.selectedOption === correctAnswer;
        }

        if (isCorrect) {
          obtainedMarks++;
          question.correct = true;
        } else {
          question.correct = false;
        }

        const bookMarked = question.bookMarked;
        return {
          answer: question.answer,
          section: question.subject,
          category: question.category,
          bookMarked: bookMarked,
          correct: question.correct,
          selectedOption: question.selectedOption,
          answered: question.answered,
          qid: question.qid,
          tag: question.tag,
          topic: question.skill_descs,
          correctAnswer: question.correct_answer,
          type: 'ACT'
        }
      });

      var test_name = localStorage.getItem('hw') === 'true'
        ? `${localStorage.getItem('hw_classname') || ''} - ${localStorage.getItem('testname') || 'ACT Practice Test'}`
        : "ACT Practice Test";
      var ori_id = localStorage.getItem('currentTest');

      const correctQuestions = newDat.filter(question => question.correct === true);
      const incorrectQuestions = newDat.filter(question => question.correct === false);
      const bookmarkedQuestions = newDat.filter(question => question.bookMarked === true); // Assuming 'bookMarked' exists
      const nullCorrectAnswerQuestions = newDat.filter(question => question.selectedOption === null);

      let data = {
        Quiz_score: newDat,//all qu
        timeframe: timeLeft,
        userId: user.u_id,
        username: user.first_name + " " + user.last_name,
        test_name: test_name,
        ori_id: ori_id, //can be null
        type: 'ACT',
        test_id: test_id,
        correctQuestions: correctQuestions,
        incorrectQuestions: incorrectQuestions,
        bookmarkedQuestions: bookmarkedQuestions,
        nullCorrectAnswerQuestions: nullCorrectAnswerQuestions,
      }

      localStorage.removeItem('currentTest');
      localStorage.removeItem('testname');
      localStorage.removeItem('type');
      localStorage.removeItem('hw');
      localStorage.removeItem('hw_classname');
      localStorage.removeItem('original_text');

      let saveResult = await axios.post(BASELINE + "tests/quiz", data);
      let saveResult2 = await axios.post(BASELINE + "removeautosavequiz", { data: { test_id: test_id, user_id: user.u_id } });

      navigate(`/results/act/quiz/${test_id}`);

    } catch (err) {
      toast.error(err.message);
      setError(err.message);
    }


  }

  const handleBookMark = (itemId) => {
    setQuestions((pre => {
      return pre.map((question) => {
        if (question.q_num === itemId) {
          if (question.bookMarked) {
            return { ...question, bookMarked: false };
          } else {
            return { ...question, bookMarked: true };
          }
        } else {
          return question;
        }
      })
    }))
  }

  async function handleSelectOption(itemId, option) {
    setQuestions(prev => {
      const updatedQuestions = prev.map(question => {
        if (question.q_num === itemId) {
          return { ...question, selectedOption: option };
        }
        return question;
      });
      // 여기서 question.id 대신 question.qid로 비교합니다.
      const updatedQuestion = updatedQuestions.find(question => question.q_num === itemId);
      setCurrentQuestion(updatedQuestion);
      return updatedQuestions;
    });
  }

  async function handleCrossOutOptions(itemId, option) {
    setQuestions((pre => {
      return pre.map((question) => {
        if (question.q_num == itemId) {
          let crossedOutOptions = question.crossedOutOptions;
          if (crossedOutOptions.includes(option)) {
            crossedOutOptions = crossedOutOptions.filter((el) => el !== option);
          } else {
            crossedOutOptions.push(option);
          }
          return { ...question, crossedOutOptions: crossedOutOptions };
        } else {
          return question;
        }
      })
    }))
  }

  const handleAnswerValueChange = (itemId, value) => {
    setQuestions(prevQuestions =>
      prevQuestions.map(question =>
        question.q_num === itemId ? { ...question, selectedOption: value } : question
      )
    );
  };

  function checkAnswer(userInput, correctAnswersJSON) {
    let correctAnswers;

    // Attempt to parse the correct answers JSON
    try {
      correctAnswers = JSON.parse(correctAnswersJSON);
    } catch (e) {
      // If parsing fails, wrap the input as a single answer in an array
      correctAnswers = [correctAnswersJSON];
    }

    // Normalize the correct answers, whether it's a single value or an array
    correctAnswers = Array.isArray(correctAnswers) ? correctAnswers : [correctAnswers];

    correctAnswers = correctAnswers.map(answer => {
      // Normalize each answer: handle numbers and fractions
      if (typeof answer === 'string' && answer.includes('/')) {
        return parseFraction(answer);  // Handle fractions
      } else if (!isNaN(answer)) {
        // Handle integers and floats
        return parseFloat(answer);
      }
      return answer.toString().toLowerCase(); // Handle string answers (e.g., 'A', 'B', etc.)
    });

    // Normalize user input for both numbers and strings
    let normalizedInput;
    if (typeof userInput === 'string' && userInput.includes('/')) {
      normalizedInput = parseFraction(userInput);  // Handle fraction input
    } else if (!isNaN(userInput)) {
      normalizedInput = parseFloat(userInput);  // Handle number input
    } else {
      normalizedInput = userInput.toString().toLowerCase();  // Handle string input (e.g., 'A', 'B', etc.)
    }

    // Check if the normalized user input is in the list of correct answers
    return correctAnswers.includes(normalizedInput);
  }

  function parseFraction(fraction) {
    let [numerator, denominator] = fraction.split('/');
    return denominator ? parseFloat(numerator) / parseFloat(denominator) : parseFloat(numerator);
  }

  async function handleNext() {
    setshowanswer(false);
    const tutorModeActive = responseData?.tutorModeActive || false;

    if (!tutorModeActive) {
      if (currentQuestion.index < questions.length - 1) {
        setCurrentQuestion(questions[currentQuestion.index + 1]);
      } else {
        setCurrentQuestion(null);
        setQuestionOverviewOpen(false);
      }
    } else {
      const currentIdx = currentQuestion.index;

      // Only ask confirmation if not already asked for the current question
      if (!askedConfirmation[currentIdx]) {
        const userResponse = window.confirm(
          "You have not selected an answer. Are you sure you want to proceed without answering?"
        );
        if (!userResponse) {
          // If the user doesn't want to proceed, return early
          return;
        }
        // If the user chooses to proceed, set confirmation as asked for this question
        setAskedConfirmation(prev => {
          const newAsked = [...prev];
          newAsked[currentIdx] = true;
          return newAsked;
        });
      }

      // Check if the selected option is correct
      const isCorrect = checkAnswer(
        currentQuestion.selectedOption,
        currentQuestion.answer
      );

      // Update the result array at the current question's index
      setResult((prevResults) => {
        const newResults = [...prevResults];
        newResults[currentQuestion.index] = isCorrect;
        return newResults;
      });

      // Use the updated result (since setState is async)
      setTimeout(() => {
        if (result[currentIdx] !== undefined) {
          if (currentQuestion.index < questions.length - 1) {
            setCurrentQuestion(questions[currentQuestion.index + 1]);
          } else {
            setCurrentQuestion(null);
            setQuestionOverviewOpen(false);
          }
        }
      }, 0);
    }
  }

  async function handleBack() {
    if (!currentQuestion) {
      setCurrentQuestion(questions[questions.length - 1]);
      return;
    }
    if (currentQuestion.index > 0) {
      setCurrentQuestion((pre) => questions[pre.index - 1])
    } else {

    }
  }

  const closeRefModal = () => {
    setShowDirectionRefModal(false);
  };

  return (
    <div className="min-h-screen bg-white relative">
      {loadingQuestions ?
        <div className="flex justify-center items-center min-h-screen">
          <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500"></div>
        </div>
        :
        <>
          <div className={`flex flex-row justify-between ${responseData?.help ? 'bg-slate-700 text-white' : 'bg-white'}`}>
            <div className="flex flex-row justify-between items-center w-[100%] mt-[20px] pb-[10px] border-b border-gray-200">
              <div className="absolute ml-[20px] flex flex-col">
                <h3>
                  {responseData?.help === true ? (
                    <strong>
                      Review: Help Session
                    </strong>
                  ) : (
                    <strong>
                      Section:  {responseData?.tag || ""}
                    </strong>)}
                </h3>
              </div>
              {responseData?.help !== true && (
                <div className="flex flex-col items-center justify-center flex-grow">
                  <div className="flex flex-col sm:flex-row items-center text-center sm:text-left">
                    <Timer
                      minutes={displayMinutes.toString().padStart(2, '0')}
                      seconds={displaySeconds.toString().padStart(2, '0')}
                    />
                  </div>
                </div>
              )}
              <div className="hidden z-[20] flex flex-row gap-2 mr-[13px]">
                {user && user?.role !== 'teacher' && responseData?.help !== true && (
                  <motion.button
                    whileTap={{ scale: 0.97 }}
                    onClick={() => askforhelp()}
                    className={`mr-[15px] flex flex-col items-center cursor-pointer hover:text-blue-900`}
                  >
                    <div className={`flex flex-row justify-center`}>
                      <FaHandBackFist size="1.5em" />
                    </div>
                    <div>
                      <p className="text-sm">Get Help</p>
                    </div>
                  </motion.button>
                )}
              </div>

              {responseData.tag === "Math" && (<>
                <div className="flex space-x-4">
                  {/* Calculator Button */}
                  <motion.button
                    whileTap={{ scale: 0.97 }}
                    onClick={() => setShowCalculator((prev) => !prev)}
                    className={`mr-4 flex flex-col items-center cursor-pointer hover:text-blue-900 ${showCalculator ? "text-blue-900" : "text-black"
                      }`}
                  >
                    <div className="flex justify-center">
                      <CiCalculator1 size="1.5em" />
                    </div>
                    <div className="mt-1">
                      <p className="text-sm">Calculator</p>
                    </div>
                  </motion.button>

                  {/* Reference Button */}
                  <motion.button
                    whileTap={{ scale: 0.97 }}
                    onClick={() => setShowDirectionRefModal(!showDirectionModalRef)}
                    className={`mr-4 flex flex-col items-center cursor-pointer hover:text-blue-900 ${showReference ? "text-blue-900" : "text-black"
                      }`}
                  >
                    <div className="flex justify-center">
                      <VscReferences size="1.5em" />
                    </div>
                    <div className="mt-1">
                      <p className="text-sm">Reference</p>
                    </div>
                  </motion.button>
                </div>
                {showDirectionModalRef && <ReferenceSheet onClose={closeRefModal} />}
              </>)}

              <div className="text-white ml-[5px] flex flex-col items-center mr-[20px]">

                <button
                  onClick={() => setShowOptions(!showOptions)}
                  className="text-black p-2 hover:text-[#7cb0eb] flex flex-col items-center"
                >
                  <BsThreeDotsVertical size="1.5em" />
                  <span className="text-xs hidden md:block">More</span>
                </button>

                {showOptions && (
                  <div className={`mt-[60px] z-[20] bg-white p-4 fixed flex flex-col space-y-4 shadow-lg rounded-lg cursor-pointer 
                  text-black ${currentQuestion?.section === "Math" && ""}`}>
                    <div
                      className="flex flex-col items-center justify-center hover:text-red-600 transition duration-300"
                      onClick={() => handleReportClick()}>
                      <BsExclamationTriangle size="1.5em" />
                      <p className="text-xs mt-1 font-medium">Report</p>
                    </div>
                    <div
                      className="flex flex-col items-center justify-center hover:text-blue-600 transition duration-300"
                      onClick={() => {
                        localStorage.setItem("dashboard", "4");
                        navigate("/main");
                      }}
                    >
                      <MdDashboard size="1.5em" />
                      <p className="text-xs mt-1 font-medium">Dashboard</p>
                    </div>
                  </div>
                )}
              </div>
            </div>


            <div className="flex flex-row gap-2">

              <div className="flex flex-col cursor-pointer">
                {showModal && (
                  <div className="fixed z-[20] inset-0 overflow-y-auto">
                    <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                      <div className="fixed inset-0 transition-opacity" aria-hidden="true">
                        <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
                      </div>
                      <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                      <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                        <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                          <div className="sm:flex sm:items-start">
                            <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                              <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                                Report Card
                              </h3>
                              <div className="mt-2">
                                <form>
                                  <label>Question ID:</label>
                                  <input type="text" className="border p-1 mt-1 w-full" value={currentQuestion.qid} readOnly />
                                  <label>Report from:</label>
                                  <input type="text" className="border p-1 mt-1 w-full" value={user.first_name + " " + user.last_name} readOnly />
                                  <label>Context:</label>
                                  <textarea
                                    className="border p-1 mt-1 w-full"
                                    value={context}
                                    onChange={handleContextChange}
                                  />
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                          <button
                            type="button"
                            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm"
                            onClick={handleSubmit2}
                          >
                            Submit
                          </button>
                          <button
                            type="button"
                            className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
                            onClick={handleCloseModal}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

            </div>
          </div>

          <div className="h-[90%]">
            <motion.div drag style={{
              width: '600px',
              height: '400px',
              position: 'absolute',
              zIndex: 100,
              display: showCalculator ? "inline" : "none",
            }}
              dragConstraints={{
                top: -125,
                right: 500,
                bottom: 300,
                left: -125,
              }}
            >
              <div id="calculator" className="w-full h-full">

              </div>

            </motion.div>
            {/* question */}
            <div className="flex flex-col">
              {loadingQuestions ? (
                <div className="flex justify-center items-center h-full">
                  <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500"></div>
                </div>
              ) : (
                currentQuestion ? (
                  <div className="flex flex-col sm:flex-row justify-center h-[50%]">
                    <Question
                      sat={responseData?.tag}
                      handleAnswerValueChange={handleAnswerValueChange}
                      handleCrossOutOptions={handleCrossOutOptions}
                      handleSelectOption={handleSelectOption}
                      currentQuestion={currentQuestion}
                      idx={1}
                      bookmarkedQuestions={bookmarkedQuestions}
                      setBookMarkedQuestions={setBookMarkedQuestions}
                      handleBookMark={handleBookMark}
                      result={result[currentQuestion.index]}
                      time={questionTimers[currentQuestion.index]}
                    />
                  </div>
                ) : (
                  <div className="min-h-[50%]">
                    <Review
                      currentQuestion={currentQuestion}
                      setCurrentQuestion={setCurrentQuestion}
                      questions={questions}
                      setQuestions={setQuestions}
                    />
                  </div>
                )
              )}
            </div>

          </div>

          <div className="z-[300] fixed inset-x-0 bottom-[2px] flex flex-row justify-around border-t-2 border-black pt-4 bg-white">
            {questionOverViewOpen && (
              <motion.div
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{
                  type: "spring",
                }}
                className="absolute z-[3000] rounded-md flex flex-row justify-center p-1 bg-white -top-40 border-[1px] border-gray-300"
              >
                <div className="bg-white min-h-[140px] max-h-[140px] min-w-[200px] max-w-[400px] flex flex-row flex-wrap rounded-md overflow-x-auto overflow-y-auto">
                  {questions.map((ques, idx) => (
                    <div
                      key={'questions-' + idx}
                      onClick={() => setCurrentQuestion(questions[idx])}
                      className={`${ques.bookMarked && 'bg-red-500 border-none text-white'} 
m-1 rounded-full border-[1px] w-[25px] h-[25px] flex flex-row justify-center items-center cursor-pointer 
${currentQuestion?.q_num === ques?.q_num && 'bg-black text-white'}
${ques.selectedOption != null && 'border-none bg-blue-700 text-white'}
border-black`}
                    >
                      {idx + 1}
                    </div>
                  ))}
                </div>
              </motion.div>

            )}

            <div className="flex flex-row items-center z-[999]">
              <p className="font-semibold text-lg">{free ? 'Free Trial' : `${user?.first_name ?? ''} ${user?.last_name ?? ''} `.trim() || 'John Doe'}</p>
            </div>
            {currentQuestion && (
              <motion.button
                whileTap={{ scale: 0.97 }}
                onClick={() => setQuestionOverviewOpen((pre) => !pre)}
                className="flex flex-row items-center gap-1 bg-black hover:bg-gray-800 text-white rounded-md p-2 cursor-pointer"
              >
                <div className="flex flex-row items-center">
                  <p className="text-sm md:text-l">
                    Question {currentQuestion?.index + 1} of {questions?.length}
                  </p>
                </div>
                <div className="flex flex-row items-center">
                  {questionOverViewOpen ? <BsChevronDown /> : <BsChevronUp />}
                </div>
              </motion.button>
            )}
            <div className="flex flex-row items-center gap-2">
              <motion.button
                whileTap={{ scale: 0.97 }}
                className="py-2 px-5 bg-slate-700 rounded-3xl text-white hover:bg-slate-800"
                onClick={() => handleBack()}
              >
                Back
              </motion.button>
              {currentQuestion ? (
                <motion.button
                  whileTap={{ scale: 0.97 }}
                  className="py-2 px-5 bg-slate-700 rounded-3xl text-white hover:bg-slate-800"
                  onClick={() => handleNext()}
                >
                  Next
                </motion.button>
              ) : (
                responseData?.help !== true && (
                  <motion.button
                    whileTap={{ scale: 0.97 }}
                    className="py-2 px-5 bg-slate-700 rounded-3xl text-white hover:bg-slate-800"
                    onClick={() => handleSubmit()}
                  >
                    Submit
                  </motion.button>
                )
              )}
            </div>
          </div>

        </>
      }
    </div>
  );
};
export default ACTQuizfromdashboard;